import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex text-[#6C757D] text-base font-normal py-6 items-center space-x-2 flex-wrap md:flex-none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-house-door",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146ZM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5Z" })
], -1)
const _hoisted_3 = {
  key: 0,
  class: "ml-2 no-underline"
}

import { useUserStore } from "@/store";
import { userHasRole } from "@/utils/roles";
import { storeToRefs } from "pinia";
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'BreadCrumbs',
  setup(__props) {

const { user } = storeToRefs(useUserStore());

const breadcrumbs = ref();
const router = useRouter();

const routes = router.getRoutes();

const shouldRemoveCourses = userHasRole(user.value.roles, ["trainer-organisation", "l4a-trainee", "l4a-trainer", "facilitator-organisation"]);

const getBreadcrumbs = () => {
  const currentMeta = router.currentRoute.value.meta;

  if (!currentMeta?.breadcrumbs) return [];

  // Apply the filtering inline
  const rawBreadcrumbs = currentMeta.breadcrumbs;
  const filteredBreadcrumbs = shouldRemoveCourses
    ? rawBreadcrumbs.filter((crumb: string) => crumb !== "Courses")
    : rawBreadcrumbs;

  console.log("Filtered breadcrumbs:", filteredBreadcrumbs);

  return filteredBreadcrumbs
    .map((breadcrumb: string) =>
      routes.find(route => route.name === breadcrumb)
    )
    .filter(Boolean); // remove any null results
};

router.afterEach(() => {
  breadcrumbs.value = getBreadcrumbs();

  // FO hack
  if (userHasRole(user.value.roles, ["trainer-organisation"])) {
    return;
  }
});

onMounted(() => {
  breadcrumbs.value = getBreadcrumbs();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(router).currentRoute.value.fullPath !== '/error')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_router_link, {
          to: "/dashboard",
          class: _normalizeClass({ 'text-blue-600': 'Dashboard' !== _unref(router).currentRoute.value.name }),
          "aria-label": _ctx.$t('home')
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["class", "aria-label"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbs.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: item,
            class: _normalizeClass(["flex capitalize", { 'text-blue-600': !item.active }]),
            to: item.active ? '' : { name: item.name },
            active: item.active
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                class: _normalizeClass({ underline: !item.active })
              }, _toDisplayString(_ctx.$t(`${item.name.toLowerCase()}`)), 3),
              (index !== breadcrumbs.value.length - 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, "/"))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["class", "to", "active"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})